import { Redirect, Route as RouteComponent, Switch } from 'react-router-dom'

import { RtmPermissionsGate } from 'components/RtmPermissionsGate/RtmPermissionsGate'
import { Route } from 'consts/routes'
import { Security } from 'modules/security/security'
import { Agent } from 'pages/Monitoring/agent'
import { Monitoring } from 'pages/Monitoring/Monitoring'
import { Ticket } from 'pages/Monitoring/ticket'
import { Root } from 'pages/Root'

const getDefaultRoute = () => {
  if (Security.canViewQueueHealth) {
    return Route.Ticket
  }
  if (Security.canViewAgentAttendance) {
    return Route.Agent
  }

  return Route.Ticket
}

export const AppRoutes = () => {
  const defaultMonitoringRoute = getDefaultRoute()

  return (
    <Root>
      <Switch>
        <RouteComponent path={Route.Monitoring}>
          <Monitoring>
            <Switch>
              <RouteComponent path={Route.Monitoring} exact>
                <Redirect to={defaultMonitoringRoute} />
              </RouteComponent>

              <RouteComponent path={Route.Ticket} exact>
                <RtmPermissionsGate permissions={['analytics.view.queues.details.list']}>
                  <Ticket />
                </RtmPermissionsGate>
              </RouteComponent>

              <RouteComponent path={Route.Agent} exact>
                <RtmPermissionsGate
                  permissions={['analytics.view.agents.attendance.details.list']}
                >
                  <Agent />
                </RtmPermissionsGate>
              </RouteComponent>

              <Redirect to={defaultMonitoringRoute} />
            </Switch>
          </Monitoring>
        </RouteComponent>

        <Redirect to={Route.Monitoring} />
      </Switch>
    </Root>
  )
}
